export const getUserData = (state) => state.userReducer || {};


// WEBPACK FOOTER //
// ./src/store/selectors/index.js